import type { FC, ReactNode } from 'react';
import { useState } from 'react';
import type { DPCalendar as CalendarType } from '@rehookify/datepicker';
import { useContextCalendars } from '@rehookify/datepicker';

import { Box } from '../../Box/Box';
import { Stack } from '../../Stack/Stack';
import { Text } from '../../Text/Text';

import { Day } from './Day';

import { days as styles_days, weekDays as styles_weekDays } from './styles.css';

interface CalendarProps {
  prevButton: ReactNode;
  nextButton: ReactNode;
  calendar: CalendarType;
  hasSelectedRange?: boolean;
}

export const Calendar: FC<CalendarProps> = ({ prevButton, nextButton, calendar, hasSelectedRange }) => {
  const { weekDays } = useContextCalendars();
  const [isHoveringOverDisabledDay, setIsHoveringOverDisabledDay] = useState(false);
  const { days, month, year } = calendar;

  return (
    <Box backgroundColor="default" p="10" cursor="default">
      <Stack direction="row" align="center">
        {prevButton}

        <Box flexGrow={1}>
          <Text userSelect="none" align="center">
            {month} {year}
          </Text>
        </Box>
        {nextButton}
      </Stack>

      <div className={styles_weekDays}>
        {weekDays.map((d) => (
          <Text align="center" key={d} userSelect="none">
            {d}
          </Text>
        ))}
      </div>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <main
        className={styles_days}
        onMouseLeave={function () {
          setIsHoveringOverDisabledDay(true);
        }}
      >
        {days.map((d) => (
          <Day
            day={{
              ...d,
              range: hasSelectedRange ? d.range : isHoveringOverDisabledDay ? '' : d.range,
            }}
            key={d.$date.toString()}
            onMouseEnter={function () {
              setIsHoveringOverDisabledDay(d.disabled);
            }}
          >
            <Text userSelect="none" align="center">
              {d.day}
            </Text>
          </Day>
        ))}
      </main>
    </Box>
  );
};

//
